import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import {
  NeedsEmailVerificationError,
  changePassword,
  checkEmailExists,
  resetPasswordWithOtp,
  sendForgotPasswordOtp,
  sendVerificationOtp,
  updateProfile,
  verifyEmailOtp,
} from '@/services/authClient'
import { authInitialized, authLoaded, authSession, initializeAuthState, loginWithPassword, logoutAuthState, refreshAuthState, registerWithPassword } from '@/services/authSession'
import { useUserStore } from '@/stores/user'

export function useAuth() {
  const route = useRoute()
  const router = useRouter()
  const userStore = useUserStore()

  const isAuthenticated = computed(() => Boolean(userStore.token))

  async function initialize() {
    await initializeAuthState()
  }

  async function refresh() {
    return refreshAuthState()
  }

  async function goToLogin(redirectTo?: string) {
    const target = redirectTo || route.fullPath
    await router.push({
      name: 'login',
      query: target && target !== '/' ? { redirect: target } : {},
    })
  }

  async function submitLogin(email: string, password: string) {
    await loginWithPassword(email, password)
  }

  async function submitSignUp(input: {
    email: string
    password: string
    firstName: string
    lastName: string
  }) {
    await registerWithPassword(input)
  }

  async function logout() {
    await logoutAuthState()
  }

  return {
    isAuthenticated,
    loaded: authLoaded,
    initialized: authInitialized,
    session: authSession,
    initialize,
    refresh,
    login: goToLogin,
    submitLogin,
    submitSignUp,
    sendVerificationOtp,
    verifyEmailOtp,
    sendForgotPasswordOtp,
    resetPasswordWithOtp,
    checkEmailExists,
    updateProfile,
    changePassword,
    NeedsEmailVerificationError,
    logout,
  }
}
